import { defineComponent as _defineComponent } from 'vue'
import sanitizeHtml from 'sanitize-html';
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Test2',
  setup(__props) {

const editValue = ref(undefined);

const cols = [
  {
    header: 'Hei',
    field: 'test',
  },
];

const items = [
  {
    test: 'Fredrik sin link: <span style="background:blue" class="mdi mdi-check"><span>test</span></span> <a href="www.test.no" style="background:green">Klikk her</a> <b class="d-flex">Hallo</b> <span>Hallo</span> <img src="https://fastly.picsum.photos/id/809/200/300.jpg?hmac=jC-cQrqqx-NPPfMItPjmHx8XKCKi5WRG46ds3qYReKI" width="100px" height="200px"></img>',
  },
];

function textToSafeHTML(htmlAsString: string) {
  // https://www.npmjs.com/package/sanitize-html
  const value = htmlAsString;
  const options: sanitizeHtml.IOptions = {
    disallowedTagsMode: 'escape',
    allowedTags: ['a', 'b', 'img', 'span'],
    transformTags: {
      a(tagName, attribs) {
        return {
          tagName,
          attribs: {
            ...attribs,
            class: 'gridLink',
          },
        };
      },
      span(tagName, attribs) {
        let classResult = '';
        if (attribs.class && attribs.class.includes(' ')) {
          const classes = attribs.class.split(' ');
          classes.forEach((item) => {
            if (item.includes('mdi')) {
              classResult += ` ${item}`;
            }
            if (item.includes('text')) {
              classResult += ` ${item}`;
            }
            if (item.includes('bg')) {
              classResult += ` ${item}`;
            }
            if (item.includes('darken')) {
              classResult += ` ${item}`;
            }
            if (item.includes('lighten')) {
              classResult += ` ${item}`;
            }
          });
        }
        // My own custom magic goes here
        return {
          tagName: 'span',
          attribs: {
            class: classResult.trim(),
          },
        };
      },
    },
    allowedAttributes: {
      a: ['href', 'class'],
      img: ['src', 'width', 'height'],
      span: ['class'],
    },
    allowedSchemesByTag: {
      a: [],
      img: ['https'],
    },
    parseStyleAttributes: false,
  };
  const result = sanitizeHtml(value, options);
  return result;
}

const icon = '<span class="mdi mdi-home"></span>';

return { __sfc: true,editValue, cols, items, textToSafeHTML, icon }
}

})